import React, { useState } from "react";
import Navbar from "./common/Navbar";
import SubFooter from "./common/SubFooter";
import Footer from "./common/Footer";
import certificateImage from "./assets/symfony-certificate.jpg";

const certificates = [
  {
    title: "Symfony & PHP Mastery: Build a Social Web App",
    issuer: "Udemy",
    instructor: "Piotr Jura",
    date: "Sept. 26, 2026",
    duration: "12 total hours",
    certificateNo: "UC-ff4a7cb9-b050-4d3b-844b-648584cb078d",
    image: certificateImage,
    pdf: "/assets/certificates/symfony.pdf",
  },
];

const Certificates = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalCertificates = certificates.length;

  const showPrevious = () => {
    setCurrentIndex((current) =>
      current === 0 ? totalCertificates - 1 : current - 1,
    );
  };

  const showNext = () => {
    setCurrentIndex((current) =>
      current === totalCertificates - 1 ? 0 : current + 1,
    );
  };

  return (
    <React.Fragment>
      <main className="flex-shrink-0">
        <Navbar />

        <div className="container px-5 certificates-page">
          <div className="text-center mb-5">
            <h1 className="display-6 fw-bolder mb-0">
              <span className="text-gradient d-inline">Certifications</span>
            </h1>
          </div>

          <div className="row gx-5 justify-content-center">
            <div className="col-lg-12 col-xl-12 col-xxl-10">
              <section
                className="certificates-carousel"
                aria-label="Professional certifications"
              >
                <div className="certificate-slider-window">
                  <div
                    className="certificate-slider-track"
                    style={{
                      transform: `translateX(-${currentIndex * 100}%)`,
                    }}
                  >
                    {certificates.map((certificate) => (
                      <div
                        className="certificate-slide"
                        key={certificate.certificateNo}
                        aria-hidden={
                          certificates[currentIndex]?.certificateNo !==
                          certificate.certificateNo
                        }
                      >
                        <article className="card border-0 rounded-4 overflow-hidden certificate-card">
                          <div className="card-body bg-gradient-secondary-to-primary p-3">
                            <div className="bg-light rounded-4 p-4 p-lg-5">
                              <div className="row gx-5 gy-4 align-items-center">
                                <div className="col-lg-6">
                                  <a
                                    href={certificate.pdf}
                                    download
                                    className="certificate-preview d-block"
                                    aria-label={`Download ${certificate.title}`}
                                  >
                                    <img
                                      src={certificate.image}
                                      alt={`${certificate.title} certificate`}
                                      className="img-fluid"
                                    />
                                    <span className="certificate-download-badge">
                                      Download PDF ↓
                                    </span>
                                  </a>
                                </div>

                                <div className="col-lg-6">
                                  <div className="certificate-content ps-lg-2">
                                    <div className="certificate-issuer mb-2">
                                      {certificate.issuer}
                                    </div>

                                    <h2 className="fw-bold text-gradient certificate-title">
                                      {certificate.title}
                                    </h2>

                                    <div className="certificate-line" />

                                    <div className="certificate-info-grid">
                                      <div>
                                        <span className="certificate-label">
                                          Instructor
                                        </span>
                                        <strong>
                                          {certificate.instructor}
                                        </strong>
                                      </div>
                                      <div>
                                        <span className="certificate-label">
                                          Completed
                                        </span>
                                        <strong>{certificate.date}</strong>
                                      </div>
                                      <div>
                                        <span className="certificate-label">
                                          Duration
                                        </span>
                                        <strong>{certificate.duration}</strong>
                                      </div>
                                      <div>
                                        <span className="certificate-label">
                                          Certificate No.
                                        </span>
                                        <strong className="certificate-number">
                                          {certificate.certificateNo}
                                        </strong>
                                      </div>
                                    </div>

                                    <a
                                      href={certificate.pdf}
                                      download
                                      className="btn certificate-download-button mt-4"
                                    >
                                      Download Certificate <span>→</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </article>
                      </div>
                    ))}
                  </div>
                </div>

                {totalCertificates > 1 && (
                  <div className="certificate-carousel-controls">
                    <button
                      type="button"
                      className="certificate-carousel-arrow"
                      onClick={showPrevious}
                      aria-label="Previous certificate"
                    >
                      ←
                    </button>

                    <div
                      className="certificate-carousel-dots"
                      aria-label="Choose certificate"
                    >
                      {certificates.map((certificate, index) => (
                        <button
                          type="button"
                          key={certificate.certificateNo}
                          className={`certificate-carousel-dot ${
                            index === currentIndex ? "active" : ""
                          }`}
                          onClick={() => setCurrentIndex(index)}
                          aria-label={`Show certificate ${index + 1}`}
                          aria-current={
                            index === currentIndex ? "true" : undefined
                          }
                        />
                      ))}
                    </div>

                    <button
                      type="button"
                      className="certificate-carousel-arrow"
                      onClick={showNext}
                      aria-label="Next certificate"
                    >
                      →
                    </button>
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
      </main>

      <SubFooter />
      <Footer />
    </React.Fragment>
  );
};

export default Certificates;
